import { RefObject, useEffect, useState } from "react";

// True while the referenced element is at least `minWidth` px wide, tracked via
// ResizeObserver. Defaults to true so nothing flashes hidden before the first
// measure, and only re-renders when the threshold is actually crossed.
export const useElementWiderThan = (
  ref: RefObject<HTMLElement>,
  minWidth: number,
): boolean => {
  const [isWider, setIsWider] = useState(true);

  useEffect(() => {
    const element = ref.current;

    if (!element) {
      return undefined;
    }

    const update = (): void => setIsWider(element.clientWidth >= minWidth);
    const resizeObserver = new ResizeObserver(update);

    resizeObserver.observe(element);
    update();

    return () => resizeObserver.disconnect();
  }, [ref, minWidth]);

  return isWider;
};
